'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg16 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 16, height: 17, viewBox: "0 0 16 17", fill: "none" }, props),
    React__namespace.createElement("g", { clipPath: "url(#16_svg__clip0_39877_64171)" },
        React__namespace.createElement("path", { d: "M2.62002 2.20361C2.2295 1.81308 1.59633 1.81307 1.20581 2.20359C0.815276 2.59411 0.815268 3.22727 1.20579 3.6178L6.58605 8.99821L1.2069 14.3775C0.816377 14.768 0.816384 15.4012 1.20691 15.7917C1.59744 16.1822 2.23061 16.1822 2.62113 15.7917L8.00025 10.4124L13.3794 15.7917C13.7699 16.1822 14.403 16.1822 14.7936 15.7917C15.1841 15.4012 15.1841 14.768 14.7936 14.3775L9.41444 8.99821L14.7947 3.6178C15.1852 3.22727 15.1852 2.59411 14.7947 2.20359C14.4042 1.81307 13.771 1.81308 13.3805 2.20361L8.00025 7.58397L2.62002 2.20361Z", fill: props.fillColor, fillOpacity: 0.92 })),
    React__namespace.createElement("defs", null,
        React__namespace.createElement("clipPath", { id: "16_svg__clip0_39877_64171" },
            React__namespace.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.997681)" })))));

exports.default = Svg16;
//# sourceMappingURL=16.js.map
